'use client';
import React from 'react';

const Button = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  type = 'button',
  className = '',
  fullWidth = false,
  loading = false,
  ...props
}) => {
  const variants = {
    primary: 'bg-primary text-white hover:shadow-brutal-hover hover:-translate-y-0.5 hover:-translate-x-0.5 shadow-brutal focus:ring-primary',
    secondary: 'bg-accent text-primary hover:shadow-brutal-hover hover:-translate-y-0.5 hover:-translate-x-0.5 shadow-brutal focus:ring-accent',
    outline: 'border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-white focus:ring-primary'
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm sm:px-5 sm:py-2.5 sm:text-[15px]',
    md: 'px-6 py-3 text-[15px] sm:px-7 sm:py-3.5 sm:text-base',
    lg: 'px-8 py-4 text-base sm:px-10 sm:py-5 sm:text-lg'
  };

  const LoadingSpinner = () => (
    <svg data-component-id="src/components/ui/Button.jsx:29:4" data-component-path="src/components/ui/Button.jsx" data-component-line="29" data-component-file="Button.jsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22animate-spin%20h-4%20w-4%20sm%3Ah-5%20sm%3Aw-5%20me-2%20sm%3Ame-3%22%7D"
      className="animate-spin h-4 w-4 sm:h-5 sm:w-5 me-2 sm:me-3"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle data-component-id="src/components/ui/Button.jsx:35:6" data-component-path="src/components/ui/Button.jsx" data-component-line="35" data-component-file="Button.jsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%2C%22className%22%3A%22opacity-25%22%7D"
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path data-component-id="src/components/ui/Button.jsx:43:6" data-component-path="src/components/ui/Button.jsx" data-component-line="43" data-component-file="Button.jsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%2C%22className%22%3A%22opacity-75%22%7D"
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );

  return (
    <button data-component-id="src/components/ui/Button.jsx:52:4" data-component-path="src/components/ui/Button.jsx" data-component-line="52" data-component-file="Button.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      type={type}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      className={`
        rounded-xl
        transition-all
        duration-300
        ease-out-expo
        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-opacity-50
        ${variants?.[variant]}
        ${sizes?.[size]}
        ${fullWidth ? 'w-full' : ''}
        ${disabled || loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:translate-y-[2px] active:translate-x-[2px] active:shadow-none'}
        ${loading ? 'relative' : ''}
        font-semibold
        font-body
        inline-flex
        items-center
        justify-center
        min-h-[44px] sm:min-h-[48px]
        touch-manipulation
        ${className}
      `?.trim()?.replace(/\s+/g, ' ')}
      aria-disabled={disabled || loading}
      aria-busy={loading}
      {...props}
    >
      {loading && <LoadingSpinner data-component-id="src/components/ui/Button.jsx:83:18" data-component-path="src/components/ui/Button.jsx" data-component-line="83" data-component-file="Button.jsx" data-component-name="LoadingSpinner" data-component-content="%7B%22elementName%22%3A%22LoadingSpinner%22%7D" />}
      <span data-component-id="src/components/ui/Button.jsx:84:6" data-component-path="src/components/ui/Button.jsx" data-component-line="84" data-component-file="Button.jsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={loading ? 'opacity-75' : ''}>{children}</span>
    </button>
  );
};

export default Button;
